import { setDefaults as e } from "./help-center-articles-search45.js";
const o = {
  type: "3rdParty",
  init(t) {
    e(t.options.react);
  }
};
export {
  o as initReactI18next
};
//# sourceMappingURL=help-center-articles-search27.js.map
